export default {
  getQuote: (state) => state.quote,
};
